import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export class PgFooterStatus {
    hidden?:boolean
    logo?:string;
    large?:boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PgFooterStatusService {
    constructor() {}

    status:PgFooterStatus = {};

    statusChange = new Subject<PgFooterStatus>()

    setStatus(status:PgFooterStatus) {
        this.status = status;
        this.statusChange.next(this.status)
    }
}
